/**
 * Invoice Ninja (https://invoiceninja.com).
 *
 * @link https://github.com/invoiceninja/invoiceninja source repository
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @license https://www.elastic.co/licensing/elastic-license
 */

export const numberFormattableColumns = [
  '.amount',
  '.balance',
  '.discount',
  '.partial',
  '.paid_to_date',
  '.custom_value1',
  '.custom_value2',
  '.custom_value3',
  '.custom_value4',
  '.credit_balance',
  '.payment_balance',
  '.custom_surcharge1',
  '.custom_surcharge2',
  '.custom_surcharge3',
  '.custom_surcharge4',
  '.exchange_rate',
  '.total_taxes',
  '.tax_rate1',
  '.tax_rate2',
  '.tax_rate3',
  '.foreign_amount',
  '.tax_amount1',
  '.tax_amount2',
  '.tax_amount3',
  '.quantity',
  '.discount',
  '.cost',
  '.tax_amount',
  '.refunded',
  '.applied',
  '.rate',
];
